import { Modal } from 'react-bootstrap'
import React from 'react'
import { useSelector } from 'react-redux';
import moment from 'moment';

const OrderDetailsModal = ({ modalShow, setModalShow }) => {
    const orderDetails = useSelector((store) => store?.order?.orderDetails);
    return (
        <div>
            <Modal
                className="order-detail-popup"
                size="lg"
                aria-labelledby="centered-modal-title"
                centered
                show={modalShow}
                onHide={() => setModalShow(false)}
            >
                <Modal.Header closeButton className="border-0 pb-0">
                    <Modal.Title id="centered-modal-title">
                        <h5 className="cart-main mb-3">Order Details</h5>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
                    <h4 className="order-info-head">Order Information</h4>
                    <div className="order-details-infoBox mb-3">
                        <div className="d-flex justify-content-between">
                            <div className="booking-date-text fw-bold mb-3">
                                Order ID: {orderDetails?.order?.id}
                            </div>
                            <span className="badge pending-badge align-self-start">
                                Pending
                            </span>
                        </div>
                        <div className="row mb-3">
                            <div className="col-12 mb-3">
                                <div className="booking-dates">
                                    <p className="mb-0 booking-date">
                                        Booking Date :{" "}
                                        <strong>
                                            {" "}
                                            {moment(orderDetails?.order?.booking_date)?.format(
                                                "DD-MM-YYYY"
                                            )}{" "}
                                            |{" "}
                                            {moment(
                                                orderDetails?.order?.booking_time,
                                                "HH:mm:ss"
                                            ).format("hh:mm A")}
                                        </strong>
                                    </p>
                                </div>
                            </div>
                            <div className="col-12 mb-3">
                                <div className="booking-dates">
                                    <p className="mb-0 booking-date">
                                        Collection Type :{" "}
                                        <strong>{orderDetails?.order?.collection_type}</strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                        {orderDetails?.order?.order_items?.length > 0 &&
                            orderDetails?.order?.order_items?.map((item, index) => (
                                <div className="items-details-box" key={index}>
                                    <h5 className="item-name">{item?.title}</h5>
                                    <p className="mb-1 item-detail-text">{item?.description}</p>
                                    <p className="mb-1 fw-medium">
                                        Flavor: {item?.add_on?.menu_item_flavor}
                                    </p>
                                    <p className="mb-1 fw-medium">
                                        Side:{item?.add_on?.menu_item_side}
                                    </p>
                                    <div className="d-flex justify-content-between my-3">
                                        <h6 className="item-name fw-semibold">
                                            {item?.quantity} * ${item?.price}
                                        </h6>
                                        <h6 className="item-name fw-semibold">
                                            ${item?.quantity * item?.price}
                                        </h6>
                                    </div>
                                </div>
                            ))}
                    </div>
                    <div>
                        <div className="order-info-head">Order Packages</div>
                        {orderDetails?.order?.order_packages?.length > 0 &&
                            orderDetails?.order?.order_packages?.map(
                                (orderPackage, index) => (
                                    <div className="items-details-box" key={index}>
                                        <h5 className="item-name">{orderPackage?.title}</h5>
                                        <p className="mb-1 item-detail-text">
                                            {orderPackage?.description}
                                        </p>
                                        <p className="mb-1 fw-medium">
                                            Flavor: {orderPackage?.add_on?.package_flavor}
                                        </p>
                                        <p className="mb-1 fw-medium">
                                            Side:{orderPackage?.add_on?.package_side}
                                        </p>
                                        <div className="d-flex justify-content-between my-3">
                                            <h6 className="item-name fw-semibold">
                                                {orderPackage?.quantity} * ${orderPackage?.price}
                                            </h6>
                                            <h6 className="item-name fw-semibold">
                                                ${orderPackage?.quantity * orderPackage?.price}
                                            </h6>
                                        </div>
                                    </div>
                                )
                            )}
                    </div>
                    <h4 className="order-info-head">Contact Information</h4>
                    <div className="order-details-infoBox">
                        <p className="item-detail-text mb-1">Address:</p>
                        <h6 className="fw-semibold">
                            {orderDetails?.order?.customer_address}
                        </h6>
                        <div className="items-details-box my-4">
                            <h5 className="order-info-head fw-bold">Payment Information</h5>
                        </div>
                        <div className="table-responsive">
                            <table className="table mb-0 no-side-borders">
                                <tbody>
                                    <tr>
                                        <th scope="row">Subtotal:</th>
                                        <td className="text-end">
                                            $
                                            {
                                                orderDetails?.order?.order_payment_details
                                                    ?.subtotal_amount
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">
                                            State Tax:
                                            <svg
                                                className="ms-2"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                                                    stroke="#031E60"
                                                    strokeWidth="2"
                                                />
                                                <path
                                                    d="M12.2422 17V12C12.2422 11.5286 12.2422 11.2929 12.0957 11.1464C11.9493 11 11.7136 11 11.2422 11"
                                                    stroke="#031E60"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M11.9922 8H12.0012"
                                                    stroke="#031E60"
                                                    strokeWidth="2.66667"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </th>
                                        <td className="text-end">
                                            ${orderDetails?.order?.order_payment_details?.state_tax}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">
                                            Platform Fee:
                                            <svg
                                                className="ms-2"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                                                    stroke="#031E60"
                                                    strokeWidth="2"
                                                />
                                                <path
                                                    d="M12.2422 17V12C12.2422 11.5286 12.2422 11.2929 12.0957 11.1464C11.9493 11 11.7136 11 11.2422 11"
                                                    stroke="#031E60"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M11.9922 8H12.0012"
                                                    stroke="#031E60"
                                                    strokeWidth="2.66667"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </th>
                                        <td className="text-end">
                                            $
                                            {
                                                orderDetails?.order?.order_payment_details
                                                    ?.platform_fee
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">
                                            Total Amount:
                                            <svg
                                                className="ms-2"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                                                    stroke="#031E60"
                                                    strokeWidth="2"
                                                />
                                                <path
                                                    d="M12.2422 17V12C12.2422 11.5286 12.2422 11.2929 12.0957 11.1464C11.9493 11 11.7136 11 11.2422 11"
                                                    stroke="#031E60"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M11.9922 8H12.0012"
                                                    stroke="#031E60"
                                                    strokeWidth="2.66667"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </th>
                                        <td className="text-end">
                                            $
                                            {
                                                orderDetails?.order?.order_payment_details
                                                    ?.total_amount
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Paid Status:</th>
                                        <td className="text-end">
                                            {orderDetails?.order?.paid_status}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Payment Type:</th>
                                        <td className="text-end">
                                            {orderDetails?.order?.payment_type}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0"></Modal.Footer>
            </Modal>
        </div>
    )
}

export default OrderDetailsModal
